import { injector as authInjector } from '@futrli/auth';
import { injector as billingInjector } from '@futrli/billing';
import { injector as organisationsInjector } from '@futrli/organisations';
import { injector as predictInjector } from '@futrli/predict';
import { ErrorTracker, TRACKING_EVENTS } from '@futrli/shared-services';

import { isDevEnvironment } from '../utils/env-utils';
import { CognitoUserData, getUserBuckets } from '../utils/user';
import { DEPLOYMENT_ENV, SENTRY_DSN_URL } from './config';
import { tracker } from './defaults';

export const injectLibs = () => {
  authInjector.set('Tracker', tracker);
  billingInjector.set('Tracker', tracker);
  organisationsInjector.set('Tracker', tracker);
  predictInjector.set('Tracker', tracker);
};

/** Sentry tracker */
export const initErrorTracker = () => {
  if (isDevEnvironment()) {
    return;
  }

  ErrorTracker.init(
    SENTRY_DSN_URL,
    DEPLOYMENT_ENV,
    /* eslint-disable-next-line @typescript-eslint/no-require-imports */
    require('../../../../package.json').version
  );
};

export const configureErrorTrackerScope = (user: CognitoUserData): void => {
  ErrorTracker.configureScope({ userId: user.attributes.sub });
};

// initislise tracking of analytics. This is called any time users successfully logs in and goes to app.
// Tracking should be reset at this point so every user has clear and new session with all analytics (mixpanel, intercom,...)
export const initLoggedInAnalyticsTracker = async (user: CognitoUserData, userHash?: string) => {
  const bucketInfo = await getUserBuckets(user);
  tracker.reset(
    typeof userHash === 'string'
      ? {
          id: user.attributes.sub,
          firstName: user.attributes.given_name,
          lastName: user.attributes.family_name,
          email: user.attributes.email,
          hash: userHash
        }
      : undefined
  );
  // Added part for Intercom identity verification (user_hash)
  tracker.identify(
    user.attributes.sub,
    {
      ...bucketInfo,
      firstName: user.attributes.given_name,
      lastName: user.attributes.family_name,
      email: user.attributes.email
    },
    {
      integrations: {
        Intercom: {
          user_hash: userHash
        }
      }
    }
  );
  tracker.track(TRACKING_EVENTS.logged_in_load, undefined, {
    integrations: { Mixpanel: false }
  });
  tracker.page(undefined, 'App Loaded', undefined, {
    Intercom: { hideDefaultLauncher: true },
    integrations: { All: false }
  });
};

export const initUserPilot = (user: CognitoUserData): void => {
  window.userpilot &&
    window.userpilot.identify(user.attributes.sub, {
      name: `${user.attributes.given_name} ${user.attributes.family_name}`,
      email: user.attributes.email
    });
};
